export enum OrderFlow {
  ONE_CLICK = '1click',
  CHECKOUT = 'checkout',
  CHECKOUT_1CLICK = 'checkout-1click',
}
